/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
(function($) {


  /* =======================================================
   * AFTER EACH PAGE LOAD
   * ======================================================= */
  function initPage(){

    /* =======================================================
     * MAP INIT
     * ======================================================= */
    if( $('#map').length ){

      var initMapInterval = setInterval(function(){ 
        if (typeof google === 'object' && typeof google.maps === 'object') {
          clearInterval(initMapInterval);
          
          var latLng = { lat: parseFloat(wordpress.lat), lng: parseFloat(wordpress.lng) };

          var styles = [
            {
                "featureType": "all",
                "elementType": "all",
                "stylers": [
                    {
                        "color": "#c45c88"
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f7e3eb"
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels",
                "stylers": [
                    {
                        "lightness": "66"
                    },
                    {
                        "saturation": "100"
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#bf5884"
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "all",
                "stylers": [
                    {
                        "lightness": "-8"
                    },
                    {
                        "gamma": "0.98"
                    },
                    {
                        "weight": "2.45"
                    },
                    {
                        "saturation": "26"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f7e3eb"
                    }
                ]
            },
            {
                "featureType": "poi.attraction",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "poi.government",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "poi.medical",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#ecbfd4"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "color": "#bc5882"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "all",
                "stylers": [
                    {
                        "lightness": -20
                    },
                    {
                        "color": "#e971a1"
                    }
                ]
            }
        ];


          var map = new google.maps.Map(document.getElementById('map'), {
            center: latLng,
            zoom: 15,
            styles: styles
          });     

          var marker = new google.maps.Marker({
            position: latLng,
            map: map,
            title: "Service d'Entraide Passerelle (SEP)",
            icon: wordpress.marker
          });           
        }
      }, 500);

    }




    /* =======================================================
     * SWIPER SLIDER
     * ======================================================= */
    if( $('.swiper-container').length ){
      var swiper = new Swiper('.swiper-container', {
        loop: true,
        autoplay: {
          delay: 5000,
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true
        },   
      });
    }


    /* =======================================================
     * ACTIVITIES TOGGLE
     * ======================================================= */
    if( $('.activities__activity__more').length ){
      $('.activities__activity__more').click(function(e){
        e.preventDefault();
        $(this).toggleClass('activities__activity__more--active');
        $(this).closest('.activities__activity').find('.activities__activity__text').toggleClass('activities__activity__text--more');
      });      
    }

  }



  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        /* =======================================================
         * MENU TOGGLE
         * ======================================================= */
        $('.hamburger').click(function(e){
          $(this).toggleClass('is-active');
          $('body').toggleClass('menu-opened');
        });

        $(window).resize(function(e){
          if( $(this).width() >= 900 ){
            $('.hamburger').removeClass('is-active');
            $('body').removeClass('menu-opened');
          }
        }); 

        /* =======================================================
         * ENGLISH BUTTON
         * ======================================================= */
        if( Modernizr.touchevents ){
          $('.banner__top__english a').click(function(e){
            e.preventDefault();
            $('.banner__top__english__hover').toggleClass('banner__top__english__hover--active');
          }); 
        } else {
          $('.banner__top__english').hover(function(e){
            $('.banner__top__english__hover').addClass('banner__top__english__hover--active');
          }, function(e){
            $('.banner__top__english__hover').removeClass('banner__top__english__hover--active');
          });
        }

        /* =======================================================
         * HEADROOM
         * ======================================================= */
        var headroom = new Headroom( $('.banner').get(0), {
          offset: 100
        });
        headroom.init();


        /* =======================================================
         * AJAX LOADING START
         * ======================================================= */
        $(document).on('ajax-loading-start', function(){
          $('html, body').animate({ scrollTop: 0 }, 500);

          if( $(window).width() < 900 && $('.hamburger').hasClass('is-active') ){
            $('.hamburger').click();
          }
        });

        /* =======================================================
         * AJAX LOADING END
         * ======================================================= */
        $(document).on('ajax-loading-end', function(){
          initPage();

          //Send page view
          if ( typeof window.gtag !== 'undefined' ){
            gtag('config', wordpress.googleAnalytics, {
              'page_title' : $('title').text(),
              'page_location': window.location.href
            });
          }
        });



      },
      finalize: function() {
        initPage();
      }
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.




